import type {
  MetadataDetail,
  MetadataSearchItem,
  OfficialEpisode,
  SourceConfig,
} from '../types'

export interface LocalIptvPreset {
  source: SourceConfig
  password?: string
}

async function getJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init)
  const body = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(body?.error || `Erro HTTP ${response.status}`)
  return body as T
}

export async function searchMetadata(query: string, type: 'movie' | 'tv', year?: number): Promise<MetadataSearchItem[]> {
  const params = new URLSearchParams({ query, type })
  if (year) params.set('year', String(year))
  const data = await getJson<{ results: MetadataSearchItem[] }>(`/api/metadata/search?${params}`)
  return Array.isArray(data.results) ? data.results : []
}

export async function getMetadataDetails(type: 'movie' | 'tv', id: number): Promise<MetadataDetail> {
  return getJson<MetadataDetail>(`/api/metadata/details?type=${type}&id=${id}`)
}

export async function getSeasonEpisodes(tvId: number, season: number): Promise<OfficialEpisode[]> {
  const data = await getJson<{ episodes: OfficialEpisode[] }>(`/api/metadata/season?tvId=${tvId}&season=${season}`)
  return data.episodes
}

export async function getTop(type: 'movie' | 'tv'): Promise<MetadataSearchItem[]> {
  const data = await getJson<{ results: MetadataSearchItem[] }>(`/api/top?type=${type}`)
  return Array.isArray(data.results) ? data.results : []
}

export async function discoverMetadata(type: 'movie' | 'tv', genre: string): Promise<MetadataSearchItem[]> {
  const params = new URLSearchParams({ type, genre })
  const data = await getJson<{ results: MetadataSearchItem[] }>(`/api/metadata/discover?${params}`)
  return Array.isArray(data.results) ? data.results : []
}

export async function getLocalIptvSources(): Promise<LocalIptvPreset[]> {
  const data = await getJson<{ sources: LocalIptvPreset[] }>('/api/local-config')
  return Array.isArray(data.sources) ? data.sources : []
}
